export default "__VITE_ASSET__cf1a17c9__"